import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Clients
export const clientsApi = {
  getAll: () => axios.get(`${API}/clients`),
  get: (id) => axios.get(`${API}/clients/${id}`),
  create: (data) => axios.post(`${API}/clients`, data),
  update: (id, data) => axios.put(`${API}/clients/${id}`, data),
  delete: (id) => axios.delete(`${API}/clients/${id}`),
};

// Bank Accounts
export const bankAccountsApi = {
  getAll: () => axios.get(`${API}/bank-accounts`),
  get: (id) => axios.get(`${API}/bank-accounts/${id}`),
  create: (data) => axios.post(`${API}/bank-accounts`, data),
  update: (id, data) => axios.put(`${API}/bank-accounts/${id}`, data),
  delete: (id) => axios.delete(`${API}/bank-accounts/${id}`),
};

// Invoices
export const invoicesApi = {
  getAll: () => axios.get(`${API}/invoices`),
  get: (id) => axios.get(`${API}/invoices/${id}`),
  getFull: (id) => axios.get(`${API}/invoices/${id}/full`),
  create: (data) => axios.post(`${API}/invoices`, data),
  update: (id, data) => axios.put(`${API}/invoices/${id}`, data),
  delete: (id) => axios.delete(`${API}/invoices/${id}`),
};

// Dashboard
export const dashboardApi = {
  getStats: () => axios.get(`${API}/dashboard/stats`),
};

// Currency helpers
export const currencySymbols = {
  USD: '$',
  GBP: '£',
  EUR: '€',
  INR: '₹',
  CAD: 'C$',
};

export const formatCurrency = (amount, currency = 'USD') => {
  const symbol = currencySymbols[currency] || '$';
  return `${symbol}${amount.toFixed(2)}`;
};

// Region-specific date formats
// US:  MM/DD/YYYY
// UK/EU/IN: DD/MM/YYYY
// CA:  YYYY-MM-DD (Canadian ISO standard)
export const dateFormatForRegion = (region) => {
  switch (region) {
    case 'US': return 'MM/DD/YYYY';
    case 'CA': return 'YYYY-MM-DD';
    case 'UK':
    case 'EU':
    case 'IN':
    default:   return 'DD/MM/YYYY';
  }
};

// Parse an invoice_date stored as either DD/MM/YYYY or YYYY-MM-DD into a JS Date.
export const parseInvoiceDate = (value) => {
  if (!value) return null;
  if (value instanceof Date) return value;
  const s = String(value).trim();
  // ISO YYYY-MM-DD
  let m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  // DD/MM/YYYY
  m = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (m) return new Date(Number(m[3]), Number(m[2]) - 1, Number(m[1]));
  // Fallback
  const d = new Date(s);
  return isNaN(d.getTime()) ? null : d;
};

const pad = (n) => String(n).padStart(2, '0');

// Format an invoice_date value for display based on client region.
export const formatInvoiceDate = (value, region) => {
  const d = parseInvoiceDate(value);
  if (!d) return value || '';
  const dd = pad(d.getDate());
  const mm = pad(d.getMonth() + 1);
  const yyyy = d.getFullYear();
  switch (region) {
    case 'US': return `${mm}/${dd}/${yyyy}`;
    case 'CA': return `${yyyy}-${mm}-${dd}`;
    case 'UK':
    case 'EU':
    case 'IN':
    default:   return `${dd}/${mm}/${yyyy}`;
  }
};

export const regions = [
  { value: 'US', label: 'United States', currency: 'USD' },
  { value: 'UK', label: 'United Kingdom', currency: 'GBP' },
  { value: 'EU', label: 'European Union', currency: 'EUR' },
  { value: 'IN', label: 'India', currency: 'INR' },
  { value: 'CA', label: 'Canada', currency: 'CAD' },
];
